<la-document-upload-dialog
  #documentUpload
  (filesChanged)="onFilesChanged($event)"
>
  <mat-table [dataSource]="fileDataSource" [seperation]="'divider'">
    <ng-container matColumnDef="document">
      <mat-header-cell *matHeaderCellDef i18n>Document</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="truncate fw-b" [matTooltip]="element.document.name">
          {{ element.document.name }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tags">
      <mat-header-cell *matHeaderCellDef i18n>Tags</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <button
          luiCab
          cdkOverlayOrigin
          #tagsOverlayOrigin="cdkOverlayOrigin"
          iconPosition="start"
          (click)="
            openTagsOverlay(tagsOverlayOrigin, element.formGroup.get('tags'))
          "
          i18n
        >
          <mat-icon svgIcon="add"></mat-icon>
          Add tag
        </button>
        <div class="d-flex flex-column ms-1">
          <lui-tag
            *ngFor="let tag of element.formGroup.get('tags').value"
            [matTooltip]="tag"
            [color]="tag | stringColor"
            [collapsed]="true"
          ></lui-tag>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="category">
      <mat-header-cell *matHeaderCellDef i18n>Category</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <form [formGroup]="element.formGroup">
          <mat-form-field subscriptSizing="dynamic" class="category-select">
            <mat-select
              placeholder="Select"
              i18n-placeholder
              formControlName="category"
            >
              <mat-option
                *ngFor="let option of data.categoryOptions"
                [value]="option"
                >{{ option }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </form>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="deletionDays">
      <mat-header-cell *matHeaderCellDef i18n>Retention</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <form [formGroup]="element.formGroup">
          <mat-form-field subscriptSizing="dynamic" class="category-select">
            <mat-select
              placeholder="Select"
              i18n-placeholder
              formControlName="deletionDays"
              laConfigFormControl="documentUploadDeletionDaysInput"
              [portalId]="data.portalId"
            >
              <mat-option value="10"> 10 days </mat-option>
              <mat-option value="30"> 30 days </mat-option>
              <mat-option value="60"> 60 days </mat-option>
              <mat-option value="90"> 90 days </mat-option>
              <mat-option value="365"> 1 Year </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="clientVisibility">
      <mat-header-cell *matHeaderCellDef i18n
        >Client visibility
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <form [formGroup]="element.formGroup">
          <mat-button-toggle
            #button
            (click)="toggleVisibility(element.formGroup, button.checked)"
            [checked]="getVisibilityValue(element.formGroup)"
          >
            <mat-icon
              [svgIcon]="button.checked ? 'visibility' : 'visibility_hidden'"
            ></mat-icon>
            <span luiButtonToggleLabel>{{
              getButtonToggleLabel(button.checked)
            }}</span>
          </mat-button-toggle>
        </form>
      </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="remove">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index">
        <button
          luiIconButton
          size="sm"
          (click)="documentUpload.removeDocument(element.document, index)"
          aria-label="Delete"
          i18n-aria-label
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedCols"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
  </mat-table>

  <ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOrigin]="activeTagsOverlayOrigin"
    [cdkConnectedOverlayOpen]="addingTagsInProgress"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="addingTagsInProgress = false"
  >
    <lui-tag-picker
      class="tag-picker p-3 w-100"
      [tags]="activeTagsControl.value"
      [availableTags]="data.tags | valuesBy : 'tag'"
      (tagsChange)="activeTagsControl.setValue($event)"
    ></lui-tag-picker>
  </ng-template>
</la-document-upload-dialog>
